import {
  createStore
} from 'vuex'

const store = createStore({
  state() {
    return {
      userGuid: "",
      fromType: "",
      returnUrl: "",

      userInfo: null,
      currentClass: null,
      levelInfo: null,
      platform: null,
      userScore: null,
      currentInt: null,
      knowledgeGraph: null,

      isSharer: false,
      isLocal: false,

      pilotNavOpen: '',
      newReply: 0,
      searchKeyword: '',

      allAchievementList: [],
      myTeamList: [],
      intList: [],
      stuList: [],

      readSetting: {},
    }
  },
  mutations: {
    userGuid(state, userGuid) {
      state.userInfo = userGuid;
    },
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    currentClass(state, currentClass) {
      state.currentClass = currentClass;
    },
    levelInfo(state, levelInfo) {
      state.levelInfo = levelInfo;
    },
    allAchievementList(state, allAchievementList) {
      state.allAchievementList = allAchievementList;
    },
    platform(state, platform) {
      state.platform = platform;
    },
    myTeamList(state, myTeamList) {
      state.myTeamList = myTeamList;
    },
    fromType(state, fromType) {
      state.fromType = fromType;
    },
    isSharer(state, isSharer) {
      state.isSharer = isSharer;
    },
    intList(state, intList) {
      state.intList = intList;
    },
    returnUrl(state, returnUrl) {
      state.returnUrl = returnUrl;
    },
    userScore(state, userScore) {
      state.userScore = userScore;
    },
    stuList(state, stuList) {
      state.stuList = stuList;
    },
    currentInt(state, currentInt) {
      state.currentInt = currentInt;
    },

    openNote(state, openNote) {
      state.openNote = openNote;
    },
    openQuestion(state, openQuestion) {
      state.openQuestion = openQuestion;
    },
    pilotNavOpen(state, pilotNavOpen) {
      state.pilotNavOpen = pilotNavOpen;
    },


    newReply(state, newReply) {
      state.newReply = newReply;
    },

    isLocal(state, isLocal) {
      state.isLocal = isLocal;
    },

    setReadSetting(state, setting) {
      state.readSetting = {
        ...state.readSetting,
        ...setting
      }
    },

    setSearchKeyword(state, keyword) {
      state.searchKeyword = keyword
    },
    
    setKnowledgeGraph(state, knowledgeGraph) {
      state.knowledgeGraph = knowledgeGraph
    }
  },
  actions: {},
  modules: {}
})

export default store